import React from "react";
import { Link } from "react-router-dom";
import "../style/Product.css";

const categories = [
  {
    name: "Tubular Motor",
    link: "/product/tubular",
    description: "Tubular motors are compact and powerful motors designed to fit inside",
    img: "/product-images/tubular motor.jpg"
  },
  {
    name: "Curtain Motor",
    link: "/product/curtain",
    description: "Curtain motors are used to automate the opening and closing of curtains.",
    img: "/product-images/curtain motors.jpg"
  },
  {
    name: "Venetian Blinds",
    link: "/product/venetian",
    description: "Venetian blind motors are designed to automate the tilting and lifting",
    img: "/product-images/venetian.jpg"
  },
  {
    name: "Control System",
    link: "/product/control",
    description : "Control systems connect all motorized products like blinds, curtains.",
    img: "/product-images/controlsystem (2).jpg"
  }
];

const Products = () => {
  return (
    <div className="product-page">
      <h1>Our Products</h1>
      <div className="product-grid">
        {categories.map((cat, idx) => (
          <div key={idx} className="product-card">
            <img src={cat.img} alt={cat.name} />
            <h3>{cat.name}</h3>
            <p>{cat.description}</p>
            <Link to={cat.link} className="product-btn">View More</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
